
import { RevDivider } from '@ds/components/Divider'
import { RevIllustration } from '@ds/components/Illustration'
import { RevLink } from '@ds/components/Link'
import { camelizeKeys } from 'humps'
import isEmpty from 'lodash/isEmpty'
import { mapGetters } from 'vuex'

import Flag from '@core/components/Flag'
import FormattedMessage from '@i18n/components/FormattedMessage'
import { PaymentIcons } from '@payment'

import PriceWrapper from '../../../PriceWrapper'
import translations from '../../CustomizationFunnel.translations'
import StepLayout from '../StepLayout'

export default {
  components: {
    RevDivider,
    RevLink,
    PriceWrapper,
    FormattedMessage,
    PaymentIcons,
    RevIllustration,
    StepLayout,
    Flag,
  },

  props: {
    grade: {
      type: Object,
      required: true,
    },
    product: {
      type: Object,
      required: true,
    },
    selectedOptions: {
      type: Array,
      required: true,
    },
    selectedColorCode: {
      type: String,
      default: '',
    },
  },

  computed: {
    translations: () => translations,

    ...mapGetters({
      countryPaymentMethods: 'countryConfig/paymentMethods',
    }),

    paymentMethods() {
      return isEmpty(this.grade.paymentMethods)
        ? this.countryPaymentMethods
        : camelizeKeys(this.grade.paymentMethods)
    },
  },
}
